import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import imag8_6 from "assets/images/poze-site/8-6-intretinere.webp";
import imag8_4 from "assets/images/poze-site/8-4-intretinere.webp";
import imag9_7 from "assets/images/poze-site/9-7-vitrate.webp";
import imag6_2 from "assets/images/poze-site/6-2-galerie-postconstruct.webp";

function ArticleContent() {
    return (
        <MKBox component="section" py={6}>
            <Container>
                <Grid container spacing={3} justifyContent="center">
                    <Grid item xs={12} lg={8}>
                        {/* Title */}
                        <MKTypography variant="h1" component="h2" mb={3} color="dark">
                            Curățenie de întreținere profesională
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Curățenia de întreținere este serviciul potrivit atunci când vrei ca spațiul tău să rămână curat zi de zi, nu doar imediat după o intervenție punctuală. Pentru birouri, clinici, cabinete și spații comerciale, un program clar de curățenie înseamnă ordine, igienă și un mediu mai plăcut pentru echipă, clienți și parteneri.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Doral Cleaning oferă servicii de curățenie de întreținere adaptate modului în care este folosit fiecare spațiu. Programul poate fi zilnic, săptămânal sau personalizat, în funcție de trafic, tipul activității și nivelul de curățenie dorit. Astfel, spațiul rămâne îngrijit constant, fără improvizații și fără să fie nevoie să gestionezi totul intern.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src={imag8_6}
                            alt="Curățenie de întreținere profesională pentru birouri, clinici și spații comerciale"
                            width="100%"
                            borderRadius="lg"
                            mb={4}
                            boxShadow="md"
                        />

                        {/* H2 */}
                        <MKTypography variant="h2" mt={5} mb={3} color="dark">
                            Ce înseamnă curățenia de întreținere și cum te ajută
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Curățenia de întreținere este serviciul care păstrează spațiul într-o stare bună de la o intervenție la alta. Nu înlocuiește curățenia generală, ci are rolul de a preveni acumularea prafului, a murdăriei și a urmelor vizibile în zonele folosite constant.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            În birouri, clinici, cabinete și spații comerciale, acest serviciu este util pentru că spațiile sunt folosite zilnic și trebuie să rămână curate în mod constant. În loc să intervii doar când apar probleme vizibile, curățenia de întreținere păstrează spațiul curat, prezentabil și mai ușor de administrat.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Pentru multe companii, este și o soluție practică. În loc să te ocupi intern de organizare, consumabile, echipamente și program, poți avea un serviciu clar, stabilit în funcție de nevoile reale ale locației. Pentru servicii dedicate mediului profesional, vezi și pagina de{" "}
                            <MKTypography
                                component="a"
                                href="/curatenie-birouri-firme-spatii-comerciale"
                                color="info"
                                fontWeight="medium"
                            >
                                curățenie birouri, firme și spații comerciale
                            </MKTypography>.
                        </MKTypography>

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Ce operațiuni sunt incluse în curățenia de întreținere
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            În mod obișnuit, curățenia de întreținere include ștergerea prafului de pe mobilier și suprafețe accesibile, aspirarea pardoselilor, spălarea podelelor, igienizarea grupurilor sanitare, golirea coșurilor de gunoi, înlocuirea sacilor menajeri și întreținerea zonelor comune. În funcție de tipul spațiului, pot fi incluse și curățarea recepției, a birourilor, a mânerelor, a prizelor, a întrerupătoarelor, a bucătăriilor de serviciu sau a altor zone folosite intens.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Lista exactă a operațiunilor se stabilește în funcție de activitatea desfășurată, fluxul de persoane și nivelul de utilizare al spațiului. Un birou mic are alte nevoi decât o clinică, un showroom sau un magazin, iar serviciul trebuie adaptat clar la aceste diferențe.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src="https://i.ibb.co/sdhMFVPL/Operatiuni-curatenie-intretinere.jpg"
                            alt="Operațiuni incluse în serviciul de curățenie de întreținere profesională"
                            width="100%"
                            borderRadius="lg"
                            mb={4}
                            boxShadow="md"
                        />

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Periodicitatea operațiunilor
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Frecvența intervențiilor se stabilește în funcție de trafic, numărul de angajați, tipul activității și standardul de curățenie dorit. Unele spații au nevoie de curățenie zilnică, altele de două sau trei intervenții pe săptămână, iar în anumite situații este suficient un program personalizat.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Un birou mic, cu trafic redus, poate funcționa foarte bine cu intervenții mai rare. În schimb, un spațiu comercial, o recepție sau o clinică are nevoie, de regulă, de o frecvență mai mare. Important este ca ritmul ales să păstreze spațiul curat, fără perioade în care aspectul locației are de suferit.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src="https://i.ibb.co/JF0f217w/Curatenie-de-intretinere-clinici.jpg"
                            alt="Periodicitatea operațiunilor în curățenia de întreținere profesională"
                            width="100%"
                            borderRadius="lg"
                            mb={4}
                            boxShadow="md"
                        />

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Diferența dintre curățenia de întreținere și curățenia generală
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Curățenia de întreținere și curățenia generală nu înseamnă același lucru. Întreținerea este periodică și urmărește păstrarea curățeniei în spațiile folosite zilnic. Curățenia generală este mai amplă, mai detaliată și se face, de regulă, la intervale mai mari sau atunci când spațiul are nevoie de o intervenție mai serioasă.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Pe scurt, curățenia de întreținere păstrează spațiul în ordine, iar curățenia generală îl readuce la un standard mai bun atunci când s-au acumulat depuneri sau când este nevoie de o curățare mai atentă. Pentru mai multe detalii despre pachetul complet aprofundat, accesați serviciul de{" "}
                            <MKTypography
                                component="a"
                                href="/curatenie-generala"
                                color="info"
                                fontWeight="medium"
                            >
                                curățenie generală
                            </MKTypography>.
                        </MKTypography>

                        {/* H2 */}
                        <MKTypography variant="h2" mt={5} mb={3} color="dark">
                            Pentru cine este potrivită curățenia de întreținere
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Curățenia de întreținere este potrivită pentru spațiile folosite constant, care trebuie să rămână curate și bine întreținute pe tot parcursul activității. Aici intră birourile, sediile de firmă, clinicile, cabinetele, magazinele, showroom-urile, recepțiile, spațiile administrative și alte locații în care circulă zilnic angajați, clienți sau parteneri.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Acest tip de serviciu este ales mai ales de companiile care vor un spațiu îngrijit fără să gestioneze intern personal, consumabile, echipamente și organizarea intervențiilor. În practică, asta înseamnă mai puține griji și un rezultat mai ușor de controlat de la o săptămână la alta.
                        </MKTypography>

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Birouri și sedii de firmă
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            În birouri, curățenia de întreținere ajută la păstrarea unui mediu de lucru ordonat și plăcut. Spațiile administrative, sălile de ședință, zonele comune, grupurile sanitare și recepțiile trebuie să arate bine în fiecare zi, nu doar înaintea unor vizite importante.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Un birou curat lasă impresia unui spațiu bine administrat. Pentru echipă, înseamnă un mediu mai confortabil. Pentru clienți și colaboratori, înseamnă o impresie bună încă de la intrare. În plus, un program constant de întreținere reduce riscul ca murdăria să se acumuleze în zonele folosite intens.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src={imag8_4}
                            alt="Curățenie de întreținere pentru birouri și sedii de firmă"
                            width="100%"
                            borderRadius="lg"
                            mb={4}
                            boxShadow="md"
                        />

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Clinici, cabinete și spații comerciale
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Clinicile, cabinetele și spațiile comerciale au, de multe ori, un ritm mai intens și cer un nivel constant de ordine. Aici, curățenia nu ține doar de aspect, ci și de felul în care spațiul este întreținut zi de zi. Suprafețele folosite frecvent, grupurile sanitare, recepțiile și zonele de așteptare trebuie să rămână curate și prezentabile în permanență.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            În astfel de locații, o intervenție periodică bine stabilită ajută la menținerea unui spațiu îngrijit și ușor de administrat. Pentru clientul final, acest lucru contează. Un spațiu curat inspiră seriozitate, atenție la detalii și grijă față de activitatea desfășurată acolo.
                        </MKTypography>

                        {/* H2 */}
                        <MKTypography variant="h2" mt={5} mb={3} color="dark">
                            Ce beneficii îți aduce curățenia de întreținere
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Un serviciu de curățenie de întreținere făcut recurent aduce stabilitate și mai puține griji. Nu mai depinzi de soluții de moment sau de intervenții făcute doar când apar probleme vizibile. Știi clar când se intervine, ce este inclus și la ce rezultat te poți aștepta.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Pentru companie, asta înseamnă economie de timp, mai puține sarcini administrative și o image mai bună a spațiului. In plus, întreținerea constantă reduce nevoia unor intervenții ample și urgente. Când spațiul este îngrijit regulat, costurile și efortul sunt mai ușor de controlat.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src="https://i.ibb.co/wNBFQWMY/beneficii-curatenie-intretinere.jpg"
                            alt="beneficii curatenie intretinere"
                            width="100%"
                            borderRadius="lg"
                            mb={4}
                            boxShadow="md"
                        />

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Program zilnic, săptămânal sau personalizat în funcție de trafic
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Unul dintre avantajele importante este flexibilitatea. Nu toate spațiile au nevoie de același ritm de curățenie, iar un program deosebit se stabilește în funcție de trafic și de activitatea reală. Unele locații au nevoie de intervenții zilnice, altele de un program săptămânal, iar uneori cea mai bună soluție este una personalizată.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Un program bine stabilit ajută ambele părți. Intervențiile sunt previzibile, spațiul rămâne curat, iar activitatea internă nu este perturbată inutil. În plus, ritmul poate fi ajustat în timp dacă volumul de lucru se schimbă.
                        </MKTypography>

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Personal calificat, echipamente profesionale și consumabile incluse
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Un alt avantaj important este că nu mai trebuie să gestionezi separat personalul, consumabilele sau echipamentele. Atunci când lucrezi cu o firmă specializată, toate aceste lucruri fac parte din organizarea serviciului.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Pentru client, asta înseamnă că nu mai pierde timp cu aprovizionarea, organizarea intervențiilor sau urmărirea consumabilelor. În loc să cauți soluții din mers, ai un serviciu organizat în funcție de spațiu și de ritmul activității.
                        </MKTypography>

                        {/* H2 */}
                        <MKTypography variant="h2" mt={5} mb={3} color="dark">
                            Cum se stabilește oferta pentru curățenia de întreținere
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Oferta pentru curățenia de întreținere nu ar trebui făcută doar dintr-o estimare rapidă a suprafeței. În realitate, contează mai mulți factori: tipul spațiului, frecvența dorită, gradul de utilizare, numărul grupurilor sanitare, existența unor zone sensibile sau intens circulate și lista concretă a operațiunilor incluse.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Un birou mic are alte nevoi decât un spațiu comercial sau o clinică. La fel, o locație în care circulă puține persoane cere un alt ritm decât una cu trafic continuu. De aceea, o ofertă bună este una adaptată situației reale, nu una făcută în grabă după un model standard.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src="https://i.ibb.co/F4WwpNCz/oferta-curatenie-intretinere.jpg"
                            alt="Cum se stabilește oferta pentru curățenie de întreținere profesională"
                            width="100%"
                            borderRadius="lg"
                            mb={4}
                            boxShadow="md"
                        />

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Factori care influențează prețul: suprafață, frecvență și tipul spațiului
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Prețul este influențat în primul rând de suprafață, dar nu doar de atât. Contează frecvența intervențiilor, programul în care se lucrează, tipul spațiului și gradul de utilizare al acestuia. Un spațiu folosit intens cere mai multă atenție și, uneori, mai multe intervenții.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Contează și numărul zonelor care trebuie întreținute: birouri, băi, recepții, holuri, spații comune, bucătării de serviciu sau suprafețe vitrate interioare. Cu cât nevoile sunt mai clare de la început, cu atât oferta poate fi mai corectă și mai ușor de urmărit.
                        </MKTypography>

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            De ce o evaluare inițială ajută la o ofertă corectă
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            O evaluare inițială ajută pentru că pune lucrurile în context real. În loc să lucrezi cu presupuneri, poți vedea exact care sunt zonele importante, cât de folosit este spațiul și ce standard de curățenie se dorește.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Etapa aceasta este utilă pentru ambele părți. Clientul primește o propunere realistă, iar firma de curățenie își poate organiza corect intervențiile. Astfel, colaborarea pornește clar, cu servicii definite și cu așteptări bine stabilite de la început.
                        </MKTypography>

                        {/* H2 */}
                        <MKTypography variant="h2" mt={5} mb={3} color="dark">
                            Servicii complementare
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            În multe cazuri, curățenia de întreținere funcționează cel mai bine atunci când este completată de alte servicii, în funcție de starea spațiului și de ce își dorește clientul. Întreținerea funcționează cel mai bine atunci când spațiul a fost deja adus la un nivel bun de curățenie sau când este completată, la nevoie, de intervenții punctuale.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Aici intră, de exemplu, curățarea geamurilor și a suprafețelor vitrate sau o curățenie post constructor înainte de începerea unui program recurent. Când aceste servicii sunt alese la momentul potrivit, întreținerea devine mai eficientă și mai ușor de menținut.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src={imag9_7}
                            alt="Servicii complementare pentru curățenie de întreținere profesională"
                            width="100%"
                            borderRadius="lg"
                            mb={4}
                            boxShadow="md"
                        />

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Când ai nevoie de curățare geamuri și suprafețe vitrate
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={3}>
                            Geamurile și suprafețele vitrate influențează mult imaginea unui spațiu, mai ales în recepții, showroom-uri, birouri moderne sau spații comerciale. Chiar dacă interiorul este bine întreținut, urmele de pe sticlă pot schimba imediat impresia generală. De aceea, în anumite situații, este util să completezi întreținerea periodică și cu un serviciu dedicat de{" "}
                            <MKTypography
                                component="a"
                                href="/curatare-geamuri-suprafete-vitrate"
                                color="info"
                                fontWeight="medium"
                            >
                                curățare geamuri și suprafețe vitrate
                            </MKTypography>.
                        </MKTypography>

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Când este necesară curățenia post constructor
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={3}>
                            Dacă spațiul este nou amenajat, renovat sau predat după lucrări, curățenia de întreținere nu este primul pas. În astfel de cazuri, este nevoie mai întâi de o intervenție mai amplă, care să elimine urmele de praf fin, reziduurile și murdăria specifică lucrărilor. După ce spațiul este adus la un standard bun, se poate trece firesc la întreținerea periodică. Pentru astfel de situații, vezi și serviciul de{" "}
                            <MKTypography
                                component="a"
                                href="/curatenie-post-construct"
                                color="info"
                                fontWeight="medium"
                            >
                                curățenie post constructor
                            </MKTypography>.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src={imag6_2}
                            alt="Curățenie post constructor înainte de curățenie de întreținere"
                            width="100%"
                            borderRadius="lg"
                            mb={4}
                            boxShadow="md"
                        />

                        {/* H2 */}
                        <MKTypography variant="h2" mt={5} mb={3} color="dark">
                            Solicită o ofertă adaptată spațiului tău
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Dacă ai nevoie de un program de curățenie de întreținere pentru birouri, clinici, cabinete sau spații comerciale, Doral Cleaning îți poate propune o variantă adaptată spațiului tău și modului în care este folosit. Frecvența intervențiilor, lista operațiunilor și programul de lucru se stabilesc astfel încât serviciul să se potrivească activității tale, nu invers.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Transmite-ne tipul spațiului, suprafața aproximativă, nivelul de trafic și frecvența dorită. Pe baza acestor informații, poți primi o ofertă și un plan de lucru potrivit pentru locația ta.
                        </MKTypography>

                        {/* H3 */}
                        <MKTypography variant="h3" mt={4} mb={2} color="dark">
                            Clienți care au ales Doral Cleaning
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={3}>
                            În timp, Doral Cleaning a colaborat cu companii din domenii diferite, de la retail și corporate, până la servicii, sănătate, comunicații și distribuție. Faptul că tot mai multe firme aleg un program profesionist de curățenie de întreținere spune mult despre nevoia de ordine, constanță și seriozitate în administrarea unui spațiu de lucru. Printre clienții care au ales serviciile Doral Cleaning se numără:
                        </MKTypography>

                        <MKBox component="ul" pl={4} mb={3}>
                            <MKTypography component="li" variant="body1" color="text">Mobexpert Pipera</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">Nestor Nestor Diculescu Kingston Petersen</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">Servier Pharma</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">Trane Romania</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">Flexa</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">AHI Carrier South Eastern Europe</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">Global Commercium Development</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">V+O Communication</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">Altimex Pro International</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">BoConcept</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">Sermedic</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">Monrol Europe</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">Elite Surface Systems</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">Gotton IT</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">Romservice Telecomunicații</MKTypography>
                            <MKTypography component="li" variant="body1" color="text">BoConcept (Bakers Digital Communication)</MKTypography>
                        </MKBox>

                        <MKTypography variant="body1" color="text" mb={4}>
                            Portofoliul de clienți include zeci de colaborări și arată că serviciile de curățenie de întreținere pot fi adaptate atât pentru birouri și sedii de firmă, cât și pentru spații comerciale, clinici sau locații cu cerințe diferite de organizare și frecvență a intervențiilor.
                        </MKTypography>

                        <MKBox p={3} mb={3} mt={3} bgcolor="light.main" borderRadius="lg">
                            <MKTypography variant="h5" mb={1} color="info">
                                Cere o ofertă personalizată!
                            </MKTypography>
                            <MKTypography variant="body2" color="text">
                                Fiecare spațiu are nevoi diferite. Nu te mulțumi cu soluții
                                standard. Cere o ofertă personalizată astăzi și hai să discutăm
                                concret despre proiectul tău!
                                <br />
                                <br />
                                Contactează-ne prin pagina de <MKTypography component="a" href="/contact-curatenie" color="info" fontWeight="medium">contact</MKTypography> sau la telefon <strong>0730 407 322</strong>
                            </MKTypography>
                        </MKBox>
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default ArticleContent;
